import { startOfQuarter as t } from "./startOfQuarter.js";
function o(r, a) {
  const e = t(r), f = t(a);
  return +e == +f;
}
export {
  o as default,
  o as isSameQuarter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/isSameQuarter.js
// module id = 1393
// module chunks = 67